<template>
  <div>
    <LogTable :shipmentCode="shipmentCode" />
  </div>
</template>
<script>
import LogTable from './components/table'
export default {
  components: { LogTable },
  props: {
    shipmentCode: { type: String, default: '' },
  },
}
</script>
